module.exports = __webpack_public_path__ + "img/item3.e50024fe.svg";